import React, { useState, useCallback, useEffect } from "react";
import { replace } from "connected-react-router";
import { useLocation } from "react-router-dom";
import { bindActionCreators } from "redux";
import { Row, Col, Button } from "antd";
import { connect } from "react-redux";
import { useIntl } from "react-intl";

import {
  put,
  post,
  checkResponse,
  checkHttpStatus,
} from "../../../modules/httpFunctions";
import TemplateForm from "../templateForm";
import { dateTimeApiFormat } from "../../..";
import {
  getMaxLdmRule,
  checkWrappings,
  sumAdrQuantity,
  sumCollisWeight,
  sumCollisVolume,
  isLdmConsignment,
  sumAdrGrossWeight,
  checkCollisForRules,
  sumNotStackableCollis,
  sumCollisLoadingMeters,
  sumCollisCalculatedWeight,
  sumAdrHandlingUnitsQuantity,
} from "../../../modules/consignmentFunctions";
import StateIcon from "../../app/generic/stateIcon";
import SaveResult from "../../app/generic/saveResult";
import {
  setResult,
  resetResult,
} from "../../../modules/redux/consignmentResult/actions";
import { handleError } from "../../../modules/errorLogger";
import { maxHandlingUnitsQuantity } from "../servicesForm/adr";
import { removeSuffixFromKeys } from "../../../modules/functions";
import { getDateFromRangePicker } from "../../app/generic/rangePickerItem";

const tryGetValue = (value, property, idx) =>
  value && value[property] && value[property].length > idx
    ? value[property][idx]
    : undefined;

function Submit({
  edit,
  rules,
  result,
  detail,
  product,
  replace,
  adrCount,
  wrappings,
  setResult,
  formCollis,
  pickupForm,
  templateWork,
  consignment,
  invoiceForm,
  deliveryForm,
  servicesForm,
  referenceForm,
  setColliIcon,
  setPickupIcon,
  setInvoiceIcon,
  setServicesIcon,
  setDeliveryIcon,
  onHideAllPanels,
  chosenPickupId,
  chosenDeliveryId,
  chosenInvoiceId,
  onLoadConsignment,
  showInvoiceAddress,
}) {
  const intl = useIntl();
  const [templateForm, setTemplateForm] = useState();
  const saveTemplateFormRef = useCallback((formRef) => {
    setTemplateForm(formRef);
  }, []);

  const { pathname } = useLocation();
  const [consignmentFromTemplate] = useState(pathname.endsWith("add"));

  const [saveWhat, setSaveWhat] = useState();
  useEffect(() => {
    setSaveWhat(
      templateWork
        ? intl.formatMessage({
            id: "consignment.template.whom",
            defaultMessage: "šablonu",
          })
        : intl.formatMessage({
            id: "consignment.whom",
            defaultMessage: "zásilku",
          })
    );
  }, [intl, templateWork]);

  const [loading, setLoading] = useState();
  const [saveForm, setSaveForm] = useState();

  const [collis, setCollis] = useState();
  const [template, setTemplate] = useState();
  const [services, setServices] = useState();
  const [reference, setReference] = useState();
  const [pickupAddress, setPickupAddress] = useState();
  const [invoiceAddress, setInvoiceAddress] = useState();
  const [deliveryAddress, setDeliveryAddress] = useState();
  const handleFormSubmit = useCallback(
    (validate, shouldSaveForm) => {
      setServices();
      setSaveForm(shouldSaveForm);
      if (shouldSaveForm) {
        setShowResult();
        onHideAllPanels();
      }

      const errors = [];
      if (formCollis.length === 0) {
        errors.push(
          intl.formatMessage({
            id: "consignment.noCollis",
            defaultMessage: "Zásilka musí obsahovat alespoň jeden kus!",
          })
        );
      }
      const isLdm = isLdmConsignment(product, formCollis, adrCount),
        maxLdmRule = getMaxLdmRule(rules),
        isAdr = adrCount > 0;
      if (isLdm && maxLdmRule < sumCollisLoadingMeters(formCollis, isAdr)) {
        errors.push(
          intl.formatMessage({
            id: "consignment.overLoadingMeters",
            defaultMessage:
              "Celkové ložné metry zásilky jsou vyšší než maximální povolené!",
          })
        );
      }
      if (!checkWrappings(formCollis, wrappings, rules)) {
        errors.push(
          intl.formatMessage({
            id: "consignment.colli.wrapping.errorShort",
            defaultMessage:
              "Zadané kusy nesplňují podmínky vybraného produktu!",
          })
        );
      }
      if (rules.weight < sumCollisWeight(formCollis)) {
        errors.push(
          intl.formatMessage({
            id: "consignment.overWeight",
            defaultMessage:
              "Celková váha zásilky je vyšší než maximální povolená!",
          })
        );
      }
      if (
        rules.calculatedWeight &&
        rules.calculatedWeight < sumCollisCalculatedWeight(formCollis, isAdr)
      ) {
        errors.push(
          intl.formatMessage({
            id: "consignment.overCalculatedWeight",
            defaultMessage:
              "Celková přepočtená váha zásilky je vyšší než maximální povolená!",
          })
        );
      }
      if (rules.volume < sumCollisVolume(formCollis)) {
        errors.push(
          intl.formatMessage({
            id: "consignment.overVolume",
            defaultMessage:
              "Celkový objem zásilky je vyšší než maximální povolený!",
          })
        );
      }
      if (adrCount > 0 && sumNotStackableCollis(formCollis) === 0) {
        errors.push(
          intl.formatMessage({
            id: "consignment.overNotStackable",
            defaultMessage:
              "Pokud je zásilka ADR, tak musí obsahovat alespoň jeden nestohovatelný kus!",
          })
        );
      }
      if (rules.count < formCollis.length) {
        errors.push(
          intl.formatMessage({
            id: "consignment.overCollis",
            defaultMessage:
              "Počet kusů zásilky je vyšší než maximální povolený!",
          })
        );
      }
      if (formCollis.some((c) => !c.wrappingId)) {
        errors.push(
          intl.formatMessage({
            id: "consignment.noWrapping",
            defaultMessage:
              "Některý kus zásilky nemá vyplněn obal! Překontrolujte prosím jednotlivé kusy.",
          })
        );
      }
      if (formCollis.some((c) => !c.description)) {
        errors.push(
          intl.formatMessage({
            id: "consignment.noDescription",
            defaultMessage:
              "Některý kus zásilky nemá vyplněn druh zboží! Překontrolujte prosím jednotlivé kusy.",
          })
        );
      }
      if (formCollis && !checkCollisForRules(formCollis, rules, isAdr)) {
        errors.push(
          intl.formatMessage({
            id: "consignment.badColliDimension",
            defaultMessage:
              "Některý kus zásilky nemá validní rozměry nebo váhu! Překontrolujte prosím jednotlivé kusy.",
          })
        );
      }
      setColliIcon(<StateIcon valid={errors.length === 0} messages={errors} />);
      setCollis(
        (!validate || errors.length === 0) &&
          formCollis &&
          (edit ? formCollis : formCollis.map((c) => ({ ...c, id: 0 })))
      );

      (pickupForm &&
        pickupForm.validateFields((err, values) => {
          setPickupIcon(<StateIcon valid={!err} />);
          setPickupAddress(
            (!err || !validate) && removeSuffixFromKeys(values, "PC")
          );
        })) ||
        setPickupIcon(<StateIcon valid={false} />);

      (deliveryForm &&
        deliveryForm.validateFields((err, values) => {
          setDeliveryIcon(<StateIcon valid={!err} />);
          setDeliveryAddress(
            (!err || !validate) && removeSuffixFromKeys(values, "DL")
          );
        })) ||
        setDeliveryIcon(<StateIcon valid={false} />);

      (servicesForm &&
        servicesForm.validateFields((err, values) => {
          const adrErrors = [];
          const maxWeight = sumCollisWeight(formCollis, true) || rules.weight,
            sumQuantity = sumAdrQuantity(values.quantity, true),
            sumGrossWeight = sumAdrGrossWeight(values.grossWeight, true);
          if (maxWeight < sumQuantity) {
            adrErrors.push(
              intl.formatMessage({
                id: "consignment.services.adr.quantity.over",
                defaultMessage:
                  "Celkové množství ADR látky je větší než maximální povolené.",
              })
            );
          }
          if (maxWeight < sumGrossWeight) {
            adrErrors.push(
              intl.formatMessage({
                id: "consignment.services.adr.grossWeight.over",
                defaultMessage:
                  "Celková váha všech ADR kusů je větší než maximální povolená.",
              })
            );
          }
          /*if (sumQuantity > sumGrossWeight) {
            adrErrors.push(
              intl.formatMessage({
                id: "consignment.services.adr.quantity.over.grossWeight",
                defaultMessage:
                  "Celkové množství ADR látky je větší než celková váha všech ADR kusů.",
              })
            );
          }*/
          if (
            maxHandlingUnitsQuantity <
            sumAdrHandlingUnitsQuantity(values.handlingUnitsQuantity, true)
          ) {
            adrErrors.push(
              intl.formatMessage({
                id: "consignment.services.adr.handlingUnitsQuantity.over",
                defaultMessage:
                  "Celkový počet ADR manipulativních jednotek je větší než maximální povolený.",
              })
            );
          }
          setServicesIcon(
            <StateIcon
              valid={!err && adrErrors.length === 0}
              messages={adrErrors}
            />
          );
          setServices(
            (!err ||
              (err.consignmentPrice && Object.keys(err).length === 1) ||
              (err.incotermId && Object.keys(err).length === 1) ||
              (err.incotermId &&
                err.consignmentPrice &&
                Object.keys(err).length === 2)) &&
              adrErrors.length === 0 &&
              values
          );
        })) ||
        setServicesIcon(<StateIcon valid={false} />);

      (invoiceForm &&
        invoiceForm.validateFields((err, values) => {
          setInvoiceIcon(<StateIcon valid={!err} />);
          setInvoiceAddress((!err || !validate) && values);
        })) ||
        setInvoiceIcon(<StateIcon valid={false} />);

      referenceForm &&
        referenceForm.validateFields((err, values) => {
          setReference(!err && values.reference);
        });

      templateForm &&
        templateForm.validateFields((err, values) => {
          setTemplate(!err && values);
        });
    },
    [
      intl,
      edit,
      rules,
      product,
      adrCount,
      wrappings,
      formCollis,
      pickupForm,
      invoiceForm,
      deliveryForm,
      servicesForm,
      templateForm,
      referenceForm,
      setColliIcon,
      setPickupIcon,
      setInvoiceIcon,
      setServicesIcon,
      setDeliveryIcon,
      onHideAllPanels,
    ]
  );

  const handleSubmit = useCallback(
    (e) => {
      e.preventDefault();
      handleFormSubmit(false, true);
    },
    [handleFormSubmit]
  );

  const handleValidationSubmit = useCallback(
    (e) => {
      e.preventDefault();
      handleFormSubmit(true, true);
    },
    [handleFormSubmit]
  );

  useEffect(() => {
    if (
      saveForm &&
      product &&
      collis &&
      services &&
      pickupAddress &&
      deliveryAddress &&
      (!showInvoiceAddress || invoiceAddress) &&
      template &&
      (!template.template || template.templateName)
    ) {
      setLoading(true);
      const data = {
        ...consignment,
        pickupAddressId:
          chosenPickupId || (consignment && consignment.pickupAddressId),
        deliveryAddressId:
          chosenDeliveryId || (consignment && consignment.deliveryAddressId),
        invoiceAddressId:
          chosenInvoiceId || (consignment && consignment.invoiceAddressId),
        templateName: template.templateName,
        customerReference: reference,
        productId: product.id,
        deliveryAddress,
        invoiceAddress,
        pickupAddress,
        collis,
        services: {
          ...services,
          nationalTransportId: services.nationalTransportIdFree
            ? ""
            : services.nationalTransportId &&
              services.nationalTransportId.length > 0
            ? services.nationalTransportId
            : undefined,
          pickupDateTime: services.pickupDateTime
            ? services.pickupDateTime.format(dateTimeApiFormat)
            : getDateFromRangePicker(services.pickupRange, 0),
          pickupDateTimeTo: getDateFromRangePicker(services.pickupRange, 1),
          deliveryDateTime: services.deliveryDateTime
            ? services.deliveryDateTime.format(dateTimeApiFormat)
            : getDateFromRangePicker(services.deliveryRange, 0),
          deliveryDateTimeTo: getDateFromRangePicker(services.deliveryRange, 1),
          fixedDeliveryDate: services.deliveryDateTime ? true : false,
          cashOnDelivery: services.cashOnDelivery
            ? {
                id:
                  (consignment &&
                    consignment.cashOnDelivery &&
                    consignment.cashOnDelivery.id) ||
                  0,
                amount: services.amount,
                currencyId: services.currencyCod,
                variableSymbol: services.variableSymbol,
              }
            : undefined,
          personalPickupDepotId: pickupAddress.personalDepotId,
          personalDeliveryDepotId: deliveryAddress.personalDepotId,
          adr: services.adr
            ? services.quantityType
                .map((_, idx) => {
                  const quantityType = tryGetValue(
                      services,
                      "quantityType",
                      idx
                    ),
                    environmentalHazard = tryGetValue(
                      services,
                      "environmentalHazard",
                      idx
                    );
                  return {
                    id: consignmentFromTemplate
                      ? 0
                      : tryGetValue(services, "adrId", idx) || 0,
                    unClassId: tryGetValue(services, "unClassId", idx),
                    unCode: tryGetValue(services, "unCode", idx),
                    chemicalName: tryGetValue(services, "chemicalName", idx),
                    environmentalHazard:
                      environmentalHazard === 1
                        ? true
                        : environmentalHazard === 2
                        ? false
                        : undefined,
                    packagingGroupId: tryGetValue(
                      services,
                      "packagingGroupId",
                      idx
                    ),
                    packagingTypeId: tryGetValue(
                      services,
                      "packagingTypeId",
                      idx
                    ),
                    quantity: tryGetValue(services, "quantity", idx),
                    handlingUnitsQuantity: tryGetValue(
                      services,
                      "handlingUnitsQuantity",
                      idx
                    ),
                    grossWeight: tryGetValue(services, "grossWeight", idx),
                    underLimitQuantity: quantityType === 1,
                    fullAdrQuantity: quantityType === 2,
                    limitedQuantity: quantityType === 3,
                    exemptedQuantity: quantityType === 4,
                    emptyPackage: quantityType === 5,
                  };
                })
                .filter((a) => (a.limitedQuantity ? a.grossWeight : a.unCode))
            : undefined,
        },
      };

      const editing =
        consignment &&
        consignment.id > 0 &&
        (!consignmentFromTemplate || templateWork);
      const response = editing
        ? put(`consignment/${consignment.id}`, data)
        : post("consignment", data);
      response
        .then((r) => {
          const { status, data } = r;
          let isSuccess, message;
          if (checkHttpStatus(r) && checkResponse(r)) {
            message = data.message;
            isSuccess = true;
          } else {
            isSuccess = false;
            message =
              (data && data.message) ||
              (status % 100 === 5
                ? intl.formatMessage({
                    id: "consignment.processErrorOnServer",
                    defaultMessage:
                      "Při zpracování zásilky nastala chyba na serveru.",
                  })
                : intl.formatMessage({
                    id: "consignment.processError",
                    defaultMessage: "Při zpracování zásilky nastala chyba!",
                  }));
          }
          setLoading(false);
          setResult(message, isSuccess);
          onLoadConsignment && onLoadConsignment();
          !editing &&
            isSuccess &&
            data.id &&
            replace(`/consignment/${data.id}/edit`);
        })
        .catch((err) => {
          setLoading(false);
          setResult(
            intl.formatMessage({
              id: "consignment.processError",
              defaultMessage: "Při zpracování zásilky nastala chyba!",
            }),
            false
          );
          handleError(err);
        });
    }
  }, [
    intl,
    replace,
    saveForm,
    collis,
    product,
    services,
    template,
    setResult,
    reference,
    consignment,
    templateWork,
    pickupAddress,
    invoiceAddress,
    deliveryAddress,
    chosenPickupId,
    chosenInvoiceId,
    chosenDeliveryId,
    onLoadConsignment,
    showInvoiceAddress,
    consignmentFromTemplate,
  ]);

  const [success, setSuccess] = useState();
  const [showResult, setShowResult] = useState();
  const [resultMessage, setResultMessage] = useState();
  useEffect(() => {
    if (result) {
      setShowResult(true);
      setSuccess(result.success);
      setResultMessage(result.message);
    }
  }, [result]);

  useEffect(() => {
    consignment && handleFormSubmit(true);
  }, [consignment, handleFormSubmit]);

  return (
    !detail && (
      <div>
        <Row gutter={[0, 50]}>
          <Col
            xl={intl.locale === "cs-CZ" ? 4 : 5}
            xxl={intl.locale === "cs-CZ" ? 3 : 4}
          >
            <Button type="primary" loading={loading} onClick={handleSubmit}>
              {intl.formatMessage({
                id: "messages.save",
                defaultMessage: "Uložit",
              })}{" "}
              {saveWhat}
            </Button>
          </Col>
          {false && (
            <Col span={6}>
              <Button
                type="primary"
                loading={loading}
                onClick={handleValidationSubmit}
              >
                {intl.formatMessage(
                  {
                    id: "consignment.saveWithValidation",
                    defaultMessage: "Uložit {saveWhat} s validací formuláře",
                  },
                  { saveWhat }
                )}
              </Button>
            </Col>
          )}
          <Col span={intl.locale === "cs-CZ" ? 15 : 14}>
            <TemplateForm
              ref={saveTemplateFormRef}
              consignment={consignment}
              setSaveWhat={setSaveWhat}
              templateWork={templateWork}
            />
          </Col>
        </Row>
        {showResult && (
          <Row gutter={[0, 50]}>
            <Col>
              <SaveResult
                success={success}
                message={resultMessage}
                templateWork={templateWork}
              />
            </Col>
          </Row>
        )}
      </div>
    )
  );
}

const mapStateToProps = ({ consignmentResult }) => ({
  result: consignmentResult.result,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      replace,
      setResult,
      resetResult,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Submit);
